import { SPORTS_PATHS } from "@shared-constants/routes";
import { SPORTS_NAVIGATION_CONFIG } from "./sports.navigation.config";

/**
 * Checks changes in params excluding sportsNavigationId param
 * @param oldParams
 * @param newParams
 */
export function checkChangesInParams(oldParams, newParams) {
  if (!oldParams && !newParams) return false;
  if (
    (!oldParams && newParams) ||
    (oldParams && !newParams) ||
    Object.keys(oldParams).length !== Object.keys(newParams).length
  )
    return true;
  for (const key in oldParams) {
    if (!newParams[key] || oldParams[key] !== newParams[key]) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if the url has the params
 * @param url
 * @param params
 */
function checkParams(url, params) {
  let errors = [];
  if (!url) {
    errors.push("Undefined url to check");
  } else {
    const targetPage = url.split("?")[0].slice(1);
    const shouldCheckParams = SPORTS_NAVIGATION_CONFIG[targetPage]?.PARAMS?.length;
    if (shouldCheckParams) {
      errors = SPORTS_NAVIGATION_CONFIG[targetPage].PARAMS.reduce((acc, current, index) => {
        if (params?.[current]) {
          return acc;
        } else {
          acc.push(`Required param ${current}`);
          // acc.push(`Required param ${index}`);
          return acc;
        }
      }, []);
    }
  }
  return { params, errors };
}

export function existsIn(element, arrayTarget, key) {
  for (let i = 0; i < arrayTarget.length; i++) {
    if (element && arrayTarget[i][key] === element[key]) {
      return true;
    }
  }
  return false;
}

export function checkParamsAndQueryParams(state, url, queryParams) {
  let shouldRedirect = false;
  let shouldUseQueryParams = false;
  if (isSportsPage(url)) {
    const checkResultParams = checkParams(url, state.params);
    if (checkResultParams.errors.length) {
      const checkResultQueryParams = checkParams(url, queryParams);
      if (checkResultQueryParams.errors.length) {
        shouldRedirect = true;
      } else {
        shouldUseQueryParams = true;
      }
    }
  }
  return { shouldRedirect, shouldUseQueryParams };
}

export function isSportsPage(page) {
  return Object.values(SPORTS_PATHS)
    .filter((elem) => !!elem && elem !== "")
    .reduce((acc, current) => page.startsWith(`/${current}`) || acc, false);
}
